export default function (...args)
{
	return {

		events: ['change'],

		getValue(default_value = document.querySelector(this.selector).hasAttribute('checked') ? 1 : 0, _this = this)
		{
			return this.safeProtoCall(default_value, _this);
		},

		setValue(value, _this = this)
		{
			this.safeProtoCall(value ? 1 : 0, _this);
		},

		isEmpty(value = this.getValue())
		{
			return value == 0;
		},

		refresh()
		{
			let node = document.querySelector(this.selector);
			if (node)
				node.checked = this.getValue() != 0;
		},

		handleEvents(ev)
		{
			this.setValue(ev.target.checked ? 1 : 0);
		}

	};
}

